
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6 11.5556H9.33333C9.9227 11.5556 10.4879 11.3214 10.9047 10.9047C11.3214 10.4879 11.5556 9.9227 11.5556 9.33333V6M20.4444 6V9.33333C20.4444 9.9227 20.6786 10.4879 21.0953 10.9047C21.5121 11.3214 22.0773 11.5556 22.6667 11.5556H26M26 20.4444H22.6667C22.0773 20.4444 21.5121 20.6786 21.0953 21.0953C20.6786 21.5121 20.4444 22.0773 20.4444 22.6667V26M11.5556 26V22.6667C11.5556 22.0773 11.3214 21.5121 10.9047 21.0953C10.4879 20.6786 9.9227 20.4444 9.33333 20.4444H6","stroke":"#10001F","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    